import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useCatalogue, displayName } from "../site/useCatalogue";
import ProductCard from "../site/ProductCard";
import QuickView from "../site/QuickView";
import { useSEO, CATALOGUE_URL } from "../seo";
import { Download } from "lucide-react";

export default function CategoryPage() {
  const { slug } = useParams();
  const { categories, products } = useCatalogue();
  const [quick, setQuick] = useState(null);
  const cat = categories.find((c) => c.slug === slug);

  useSEO(
    cat ? `${cat.name} — Sepla Hotelware` : "Sepla Hotelware",
    cat ? cat.intro : "Sepla stainless steel hotelware."
  );

  if (!cat) {
    return (
      <main className="page page-pad">
        <p className="pempty">Unknown category. <Link to="/products">See all products</Link>.</p>
      </main>
    );
  }
  const list = products.filter((p) => p.category === slug);
  const dark = ["cereal-dispensers", "buffet-service", "bowls"].includes(slug);

  return (
    <main className={`page ${dark ? "page-dark" : ""}`} data-testid="category-page">
      <header className="cat-head">
        <div className="cat-head-in">
          <span className="cat-num" aria-hidden="true">{cat.num}</span>
          <div>
            <h1 className="cat-name" data-testid="category-name">{displayName(cat.name)}</h1>
            <p className="cat-intro">{cat.intro}</p>
            <p className="cat-material">Material — {cat.material}</p>
            <a className="btn btn-ghost cat-catalogue" href={CATALOGUE_URL} download data-testid="category-download-catalogue"><Download size={14} /> Download catalogue</a>
          </div>
        </div>
      </header>
      <div className="pgrid page-pad" data-testid="category-grid">
        {list.map((p) => <ProductCard key={p.code} product={p} onQuickView={setQuick} />)}
      </div>
      <QuickView product={quick} onClose={() => setQuick(null)} />
    </main>
  );
}
